import { render, staticRenderFns } from "./EditBlackListAttributes.vue?vue&type=template&id=2c3dd8ed&scoped=true"
import script from "./EditBlackListAttributes.vue?vue&type=script&lang=js"
export * from "./EditBlackListAttributes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c3dd8ed",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jquispe/itcm-inca-platform-app/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2c3dd8ed')) {
      api.createRecord('2c3dd8ed', component.options)
    } else {
      api.reload('2c3dd8ed', component.options)
    }
    module.hot.accept("./EditBlackListAttributes.vue?vue&type=template&id=2c3dd8ed&scoped=true", function () {
      api.rerender('2c3dd8ed', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/apps/attributes/modules/managment/EditBlackListAttributes.vue"
export default component.exports